import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import axios from 'axios'

import 'bootstrap'
import './assets/style.scss'
import './assets/custom.css'

const app = createApp(App)

let accountUrl = process.env.VUE_APP_ACCOUNT_URL

if( window.location.href.includes('test')){
    accountUrl = "https://account-test.ecosim.hu/"
}

axios.defaults.baseURL = process.env.VUE_APP_API_PATH;
axios.defaults.withCredentials = true
app.config.globalProperties.$axios = axios
app.config.globalProperties.$accountUrl = accountUrl
axios.defaults.headers.common = {
    'Authorization': `Bearer ${localStorage.getItem('n120_session_hash')}`
}

app.use(router,axios)
app.mount('#app')
